"use strict";

// src/script-loader.ts
var injectAgentScript = (doc) => (dep) => {
  const script = doc.createElement("script");
  if (dep.scriptType) {
    script.type = dep.scriptType;
  }
  script.id = dep.agentScriptId;
  script.src = dep.agentSrc;
  let windowErrorEventListener;
  const result = new Promise((resolve, reject) => {
    var _a;
    windowErrorEventListener = (ev) => {
      if (doc.currentScript === script) {
        reject(ev);
      }
    };
    (_a = doc.defaultView) == null ? void 0 : _a.addEventListener("error", windowErrorEventListener);
    script.addEventListener("load", () => resolve());
    script.addEventListener("error", reject);
  }).finally(() => {
    var _a;
    return (_a = doc.defaultView) == null ? void 0 : _a.removeEventListener("error", windowErrorEventListener);
  });
  doc.head.appendChild(script);
  return result;
};
var checkAgentScriptExist = (doc) => (dep) => {
  const script = doc.getElementById(dep.agentScriptId);
  return (script == null ? void 0 : script.id) === dep.agentScriptId;
};
var loadScript = (doc) => async (dep) => {
  const agentScriptExist = checkAgentScriptExist(doc)(dep);
  if (agentScriptExist) {
    throw new Error(
      "Livecycle agent script already injected, this may be due to multiple initialization"
    );
  }
  return await injectAgentScript(doc)(dep);
};

// src/index.ts
var RETURN_TO_QUERY_PARAM = "___lc_return_to";
var Configs = {
  agentSrc: "https://livecycle.dev/agent.js",
  agentScriptId: "lc__agent",
  scriptType: "module"
};
function registerSDKValidateHandler() {
  window == null ? void 0 : window.addEventListener("message", (e) => {
    var _a;
    if (e.data !== null && typeof e.data === "object" && "type" in e.data && e.data.type === "livecycle-sdk-check") {
      (_a = e.source) == null ? void 0 : _a.postMessage(
        {
          type: "livecycle-sdk-check-response"
        },
        {
          targetOrigin: e.origin
        }
      );
    }
  });
}
var Livecycle = {
  async init(userConfigs = {}) {
    try {
      registerSDKValidateHandler();
      if (window.name === "liveEnv") {
        localStorage.removeItem(RETURN_TO_QUERY_PARAM);
        await loadScript(document)(Configs);
      } else {
        returnToEditorIfNeeded();
      }
    } catch (e) {
      console.debug("failed to init livecycle-agent", e);
    }
  }
};
function validateLivecycleUrl(returnTo) {
  try {
    const url = new URL(returnTo);
    return url.hostname.match(/.*?livecycle.(dev|xyz)$/) !== null;
  } catch (error) {
    console.debug("failed to use returnTo url", error);
    return false;
  }
}
function returnToEditorIfNeeded() {
  let returnToFromStorage;
  try {
    returnToFromStorage = localStorage.getItem(RETURN_TO_QUERY_PARAM);
  } catch (e) {
    console.warn("failed to read item from local storage");
    return;
  }
  if (returnToFromStorage && validateLivecycleUrl(returnToFromStorage)) {
    const returnTo2 = new URL(returnToFromStorage);
    returnTo2.searchParams.set(
      "page",
      `${document.location.pathname}${document.location.search}${document.location.hash}`
    );
    localStorage.removeItem(RETURN_TO_QUERY_PARAM);
    const sReturnTo = returnTo2.toString();
    window.addEventListener("beforeunload", () => {
      if (returnToFromStorage && document.location.href !== sReturnTo) {
        localStorage.setItem(RETURN_TO_QUERY_PARAM, returnToFromStorage);
      }
    });
    window.addEventListener("load", function() {
      setTimeout(function() {
        document.location.href = sReturnTo;
      }, 2e3);
    });
    return;
  }
  const returnTo = new URLSearchParams(window.location.search).get(RETURN_TO_QUERY_PARAM);
  if (returnTo && validateLivecycleUrl(returnTo)) {
    localStorage.setItem(RETURN_TO_QUERY_PARAM, returnTo);
    window.alert(`Hey! \u{1F44B}
  Please sign in and we'll return you right back to Livecycle`);
    return;
  }
}
module.exports = Livecycle;
//# sourceMappingURL=index.js.map
